import { render, staticRenderFns } from "./PFReclaimListFront.vue?vue&type=template&id=2a80a743&scoped=true"
import script from "./PFReclaimListFront.vue?vue&type=script&lang=js"
export * from "./PFReclaimListFront.vue?vue&type=script&lang=js"
import style0 from "./PFReclaimListFront.vue?vue&type=style&index=0&id=2a80a743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a80a743",
  null
  
)

export default component.exports